<!-- 首页 -->
<template>
  <div class="cet-index">
    <HeaderTop
      ref="HeaderTop"
      :subNavList="subNavList"
      @showYearBox="showYearBox"
      @sendCatalog="receiveCatalog"
    />
    <div v-show="selectedSubNav === 0">
      <!-- 轮播 -->
      <Banner :bannerList="bannerList" />
      <!-- 金刚区域 -->
      <CustomButton :iconLists="iconLists" />
      <!-- 首页胶囊区 -->
      <Advertisement :advertLists="advertLists" :advertisement="advertisement" />
      <!-- 直播公开课 -->
      <RecentLiveCourse
        ref="liveCours"
        :classCode="8"
        @openLive="openLive"
        @showRemindBox="showRemindBox"
        :examType="24"
      />
      <!-- 热销课程榜单 -->
      <!--  测试 :hotSaleId='114'-->
      <HotSaleCourse :hotSaleId="ENV === 'test' || ENV === 'local' ? 114 : 233" :pageName="24" />
      <!-- 考研咨询专区 -->
      <postgraduateChat
        v-show="postgraduateChatList.length"
        :postgraduateChatList="postgraduateChatList"
      />

      <!-- 优惠券抢购专区 -->
      <HomeCoupon :examType="24" :couponadvertList="couponadvertList" />

      <!-- 精选课程 -->
      <HotCourse ref="hotCourse" :examSeason="24" />
      <HomePop v-if="isPopBox" @closePopBox="closePopBox" :popupData="popupData" />
    </div>
    <!-- 专业课课程列表，没有广告位 -->
    <div v-show="selectedSubNav !== 0 && courseTabDetails.showType !== 7" class="courseCard">
      <CourseCard v-if="isCourseCard" :courseTabDetails="courseTabDetails" />
    </div>
    <webview v-if="courseTabDetails.showType === 7" :courseTabDetails="courseTabDetails" />

    <!-- 选择考季 -->
    <SelectType v-if="isYearTabBox" :newData="newData" @closeYearBox="closeYearBox" />
    <!-- 开播提醒弹框 -->
    <RemindBox v-if="isRemindBox" @closeRemindBox="closeRemindBox" />
    <!-- 直播弹出 -->
    <MultipleLiveCourse
      :videoList="videoList"
      :openCourseId="openCourseId"
      :gioEnter="gioEnter"
      v-if="showLive"
      @closeLive="closeLive"
    />

    <!-- 悬浮聊天 -->
    <Chat />

    <!-- 底部广告位 -->
    <transition name="fade">
      <Bottomadvert
        :examType="24"
        v-show="bottomadvertList && selectedSubNav === 0 && isShowAdvert"
        :bottomadvertList="bottomadvertList"
        :bottomAreaHeight="bottomAreaHeight"
      />
    </transition>
  </div>
</template>

<script>
const ENV = process.env.VUE_APP_ENV;
import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import iconList from '@/utils/iconsTypes';
import HeaderTop from '@/pages/arkHome/components/appHeaderTop.vue';
import SelectType from '@/pages/arkHome/components/selectTypes.vue';
import { reqTypeList, reqMajorAd, reqAdvertPlaying, reqProducts } from '@/api/home';
import {
  gioJumpType,
  gioPlatform,
  homeGioAdShow,
  isOnloadMantisChatHome,
  deleteMantisChat, deepCopy,
} from '@/utils/tools';
import { reqCombinationlist } from '@/api/combination';
import CourseCard from '@/pages/arkHome/courseCard.vue';
import Banner from '@/pages/arkHome/components/bannerVant.vue';
import CustomButton from '@/pages/arkHome/components/customButton.vue';
import RecentLiveCourse from '@/pages/arkHome/components/recentLiveCourse.vue';
import HotCourse from '@/pages/arkHome/components/hotCourse.vue';
import RemindBox from '@/components/remindBox/index.vue';
import HomePop from '@/pages/arkHome/components/homePop.vue';
import postgraduateChat from '@/pages/arkHome/components/postgraduateChat.vue';
import Bottomadvert from '@/components/bottomadvert/index.vue';
import HotSaleCourse from '@/pages/arkHome/components/hotSaleCourse.vue';
import Advertisement from './components/advertisement.vue';
import MultipleLiveCourse from '../../components/multipleLiveCourse/index.vue';
import Chat from './components/chat.vue';
import HomeCoupon from '../../components/homeCoupon/index.vue';
import webview from '@/pages/exam25/components/webview.vue';

export default {
  data() {
    return {
      ENV,
      isYearTabBox: false,
      navList: [], // 导航栏
      newData: [], // 合并图片后的数据
      subNavList: [], // 二级类目列表
      courseInfoData: [],
      finished: false,
      loading: false,
      page: 1,
      ids: [],
      bgShow: true,
      showLoad: false,
      isEmpty: false,
      bannerList: [], // 轮播图数据
      iconLists: [], // 金刚区
      advertLists: [], // 胶囊区
      advertisement: {}, // 长图广告未
      popupData: {}, // 弹窗
      isPopBox: false,
      isRemindBox: false, // 开播提醒弹框
      videoList: [],
      openCourseId: '',
      showLive: false,
      postgraduateChatList: [], // 考研咨询专区
      selectedSubNav: 0, // 当前选中的类目
      courseTabDetails: {}, // tab詳情
      isCourseCard: false,
      courseTabArr: [], // 23考研
      startX: 0, // 坐标
      startY: 0,
      isShowAdvert: true, // 是否展示广告位
      bottomadvertList: [], // 底部广告位
      couponadvertList: [], // 优惠券广告位
      bottomAreaHeight: 0,
      gioEnter: '首页',
    };
  },

  components: {
    Chat,
    HeaderTop,
    SelectType,
    Banner,
    CourseCard,
    CustomButton,
    RecentLiveCourse,
    HotCourse,
    RemindBox,
    HomePop,
    Advertisement,
    MultipleLiveCourse,
    postgraduateChat,
    Bottomadvert,
    HomeCoupon,
    HotSaleCourse,
    webview,
  },
  watch: {
    userInfo: {
      handler() {},
    },
    courseTabDetails: {
      handler(val) {
        this.isCourseCard = false;
        this.$nextTick(() => {
          this.isCourseCard = true;
          this.courseTabDetails = val;
        });
      },
    },
    deep: true,
  },
  computed: {
    ...mapState(['currentYear', 'userInfo']),
  },
  beforeRouteLeave(to, from, next) {
    this.deleteMantis();
    next();
  },
  created() {},
  mounted() {
    this.getTypeList();
    this.getBanner();
    document.title = '启航教育';
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
    sessionStorage.removeItem('fromPageUrl'); // 清除referer记录，提交订单接口用referer
    this.checkRoute();
    // 监听滑动事件
    this.bindEvent();
  },
  destroyed() {},
  methods: {
    ...mapActions(['setcurrentyear']),
    // 请求广告位
    async getBanner() {
      const paramsList = [
        'App220001',
        'App240002',
        'App240003',
        'App240005',
        'App240418',
        'zx002',
        'App101',
        'App103',
      ];
      const res = await reqAdvertPlaying(paramsList);
      if (res.code === 0) {
        // 首页banner
        this.bannerList = res.data?.find(
          (item) => item.adCode === paramsList[0],
        )?.advertisingContentWebInfoRespVOS;
        // 请求金刚区
        this.iconLists = res.data?.find(
          (item) => item.adCode === paramsList[1],
        )?.advertisingContentWebInfoRespVOS;
        // 请求胶囊区
        this.advertLists = res.data?.find(
          (item) => item.adCode === paramsList[2],
        )?.advertisingContentWebInfoRespVOS;
        // 短胶囊最多展示两个，取sort 最大的两个
        if (this?.advertLists?.length > 2) {
          this.advertLists = this.advertLists.slice(0, 2);
        }
        // 首页弹窗
        this.popupData = res.data?.find(
          (item) => item.adCode === paramsList[3],
        )?.advertisingContentWebInfoRespVOS[0];
        if (this.popupData) {
          if (!this.$root.$data.isApp) {
            this.isPopBox = true;
            this.gioEvent((this.gioType = 1));
          }

          if (sessionStorage.getItem('HomePopup24')) {
            this.isPopBox = false;
          }
        }
        // 首页长图广告位
        this.advertisement = res.data?.find(
          (item) => item.adCode === paramsList[4],
        )?.advertisingContentWebInfoRespVOS[0];
        // 首页考研咨询广告位
        this.postgraduateChatList =
          res.data?.find((item) => item.adCode === paramsList[5])
            ?.advertisingContentWebInfoRespVOS || [];
        // 首页底部广告位
        this.bottomadvertList = res.data?.find(
          (item) => item.adCode === paramsList[6],
        )?.advertisingContentWebInfoRespVOS;
        if (this.bottomadvertList && !this.$root.$data.isApp) {
          this.bottomadvertList[0].adPosition_var = '24考研-首页-底部广告';
          homeGioAdShow(this.bottomadvertList);
        }
        // 首页优惠券广告位
        this.couponadvertList = res.data?.find(
          (item) => item.adCode === paramsList[7],
        )?.advertisingContentWebInfoRespVOS;
        if (this.couponadvertList && !this.$root.$data.isApp) {
          this.couponadvertList[0].adPosition_var = '24考研-首页-优惠券广告';
          homeGioAdShow(this.couponadvertList);
        }

      }
    },
   async checkRoute() {
      const { code } = this.currentYear;
      const { path } = this.$route;
      if (!(Number(code) === 8 && path === '/exam24')) {
        this.$refs.HeaderTop.jumpPage(code);
        if(Number(code) === 8){
         //24首页添加螳螂 其他不加
         await this.$root.getUserInfo();
         this.showMantisChatBox();
        }
      }
    },
    goback() {
      sessionStorage.setItem('back', true);
    },

    async getTypeList() {
      const res = await reqTypeList('HOME_EXAM_CONFIG_H5');
      if (res.code === 0) {
        this.navList = res.data;
        const remark = this.navList.find((item) => item.code === '8')?.remark;
        this.courseTabArr = JSON.parse(remark);
        this.subNavList = JSON.parse(remark || '{}');
        this.subNavList.unshift({ id: 0, name: '精选' });
        this.navList.map((item) => {
          // eslint-disable-next-line array-callback-return
          iconList.map((e) => {
            if (item.code === e.code) {
              Object.assign(item, e);
            }
          });
          return item;
        });
        this.newData = this.navList;
      }
    },

    // 显示选择年份弹框
    showYearBox() {
      this.isYearTabBox = true;
      if (this.$root.$data.isApp) {
        this.$sendToApp('hideBottomSidebar');
      }
    },
    // 关闭选择年份弹框
    closeYearBox() {
      this.isYearTabBox = false;
      // App显示底部导航
      if (this.$root.$data.isApp) {
        this.$sendToApp('showBottomSidebar');
      }
    },
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closeRemindBox() {
      // 关闭开播提醒
      this.isRemindBox = false;
    },
    closePopBox() {
      this.isPopBox = false;
      // 存session 控制弹窗
      sessionStorage.setItem('HomePopup24', true);
      this.gioEvent((this.gioType = 2));
    },
    async getLoginAfter() {
      await this.$root.getUserInfo();
      setTimeout(() => {
        this.getTypeList();
      }, 500);
      await this.$refs.hotCourse.getRecommend();
      await this.$refs.liveCours.getOpenCourse();
    },
    getLogin(APPSESSION) {
      const ua = navigator.userAgent.toLowerCase();
      const cookieToken = /ohos/.test(ua) ? APPSESSION.token : APPSESSION;
      if ((window?.navigator?.userAgent || '').includes('iqihang')) {
        window.localStorage.setItem('accessToken', cookieToken || '');
        this.getLoginAfter();
      }
    },
    closeLive() {
      this.showLive = false;
    },
    openLive(data) {
      this.videoList = data.videoList;
      this.openCourseId = data.openCourseRecordId;
      this.showLive = true;
    },
    receiveCatalog(data) {
      this.selectedSubNav = data.index;
      if (data.index === 0) {
        setTimeout(() => {
          this.getTypeList();
        }, 500);
      } else {
        this.courseTabDetails = this.courseTabArr[data.index - 1];
      }
    },
    // 查询广告位
    async getCourseAd(recommendId) {
      this.showLoad = true;
      this.isEmpty = false;
      this.courseInfoData = [];
      const { code, data } = await reqMajorAd(recommendId);
      if (code === 0 && data?.length) {
        const { recommendContentVOList } = data[0];
        this.getMajorList(recommendContentVOList);
      } else {
        this.showLoad = false;
        this.isEmpty = true;
      }
      this.resetProductData([]);
    },
    // 查询课程卡片信息
    async getMajorList(recommendContentVOList) {
      const allProductIds = [];
      const allPackageIds = [];
      (recommendContentVOList || []).forEach((child) => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};

      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetProductData(res?.data || [], 2);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const allCourse = [];
        recommendContentVOList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.recommendType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && allCourse.push(findRes);
        });
        this.courseInfoData = allCourse;
        this.showLoad = false;
        this.isEmpty = !allCourse?.length;
      });
    },
    // 自定义数据格式
    resetProductData(courseList) {
      courseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return courseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    gioEvent(type) {
      const { title, skipType } = this.popupData;
      const adId = this.popupData.id;
      if (type === 2) {
        // 关闭广告埋点
        // eslint-disable-next-line
        gio('track', 'adClose_event', {
          adPosition_var: '24考研-首页-弹窗', // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      } else {
        // 广告曝光
        // eslint-disable-next-line
        gio('track', 'adShown_event', {
          adPosition_var: '24考研-首页-弹窗', // 广告位置
          pageName_var: '首页', // 页面名称
          adSequence_var: null, // 广告序号
          adId_var: adId.toString(), // 广告ID
          adName_var: title, // 广告名称
          linesBusiness_var: '考研', // 业务线
          jumpType_var: gioJumpType(skipType), // 跳转类型
          platform_var: gioPlatform(),
        });
      }
    },

    // 滑动
    touchStart(evt) {
      try {
        const touch = evt.touches[0]; // 获取第一个触点
        const x = Number(touch.pageX); // 页面触点X坐标
        const y = Number(touch.pageY); // 页面触点Y坐标
        // 记录触点初始位置
        this.startX = x;
        this.startY = y;
      } catch (e) {}
    },

    touchMove(evt) {
      try {
        const touch = evt.touches[0]; // 获取第一个触点
        // x = Number(touch.pageX), //页面触点X坐标
        const y = Number(touch.pageY); // 页面触点Y坐标
        // 判断滑动方向
        if (y - this.startY < 0) {
          this.isShowAdvert = false;
        } else {
          this.isShowAdvert = true;
        }
      } catch (e) {
        console.log(e.message);
      }
    },

    // 绑定事件
    bindEvent() {
      document.addEventListener('touchstart', _.debounce(this.touchStart, 300, true), false);
      document.addEventListener('touchmove', _.debounce(this.touchMove, 300, true), false);
    },
    // 展示客服弹窗
    showMantisChatBox() {
      const infouser = JSON.parse(localStorage.getItem('userInfo')) || this.userInfo;
      isOnloadMantisChatHome(infouser);
    },
    //移出客服弹窗
    deleteMantis() {
      deleteMantisChat();
    },
  },
};
</script>

<style lang="scss" scoped>
.cet-index {
  width: 100%;
  min-height: 100vh;
  padding: 200px 0 20px 0;
  background: #fefeff;
  ::v-deep .sub-nav {
    margin: 0 0 30px 0;
  }
}
.course-list {
  position: relative;
  padding: 0 40px;
}

::v-deep .van-loading {
  margin: 100px 0;
  text-align: center;
}
.courseCard {
  padding: 0 40px;
}

// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
